<template>
<!-- 用户管理 -->
    <div class="table_container">
        <el-card class="fatherCard">
            <div slot="header" class="clearfix">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item class="currentLocation"><i class="el-icon-location-outline"></i> 当前位置</el-breadcrumb-item>
                    <el-breadcrumb-item>系统管理</el-breadcrumb-item>                
                    <el-breadcrumb-item>用户管理</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="list_container">
                <!--条件搜索区域-->
                <div class="search_container" >
                    <div class="addButtonDiv">
                        <div>
                            <el-input v-model="queryParams.relayName"  @keyup.enter.native="getUserList()" @clear="getUserList" clearable autofocus="true" placeholder="输入姓名关键字模糊查询" class="searchinput"></el-input>
                            <el-button type="primary" @click="getUserList()" icon="el-icon-search"></el-button>  
                            <el-button type="success" @click="openDialog('add')" class="addButton">新增</el-button>
                        </div>
                    </div>
                    <el-button type="danger" @click="deleteSelectedUsers()" class="searchButton">批量删除</el-button>
                </div>
                <!--用户信息展示表格-->
                <el-table :data="userList" max-height="640px"  stripe :header-cell-style="{background:'#eef1f6',color:'#606266'}"
                ref="multipleTable" @selection-change="handleSelectionChange"> 
                    <el-table-column  type="selection" width="55"></el-table-column>
                     <el-table-column type="index" label="序号" width="50"  align="center"></el-table-column>           
                    <el-table-column prop="userId" label="用户ID"   v-if="false"></el-table-column>
                    <el-table-column prop="password" label="密码"   v-if="false"></el-table-column>
                    <el-table-column prop="userName" label="用户名"   align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="relayName" label="姓名" align="center"></el-table-column>
                    <el-table-column prop="userTel" label="联系电话"  align="center"></el-table-column>
                    <el-table-column prop="userSex" label="性别"  align="center">
                        <template slot-scope="scope">{{ scope.row.userSex === '0' ? '女' : '男' }}</template>
                    </el-table-column>
                    <el-table-column sortable prop="roles" label="角色类别" width="160" align="center">
                        <template slot-scope="scope">{{ scope.row.roles[0]? scope.row.roles[0].roleName : ''}}</template>
                    </el-table-column>
                    <el-table-column prop="email" label="邮箱"  align="center" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="state" label="员工状态"  align="center">
                        <template slot="header" >
                            <div class="switchDiv">
                                <span>用户状态</span>
                                <el-switch v-model="switchValue"  active-color="#13ce66"  inactive-color="#909399"></el-switch>
                            </div>
                        </template>
                        <template slot-scope="scope">{{ scope.row.state === '0' ? '禁用' : '在用' }}</template>
                    </el-table-column>
                    <el-table-column  label="操作" width="200"  align="center">
                        <template slot-scope="scope">
                            <el-button @click="openDialog(scope.row)" :disabled="scope.row.userName=='admin'" type="primary" size="small">编辑</el-button>
                            <el-button @click="modifyState(scope.row)" :disabled="scope.row.userName=='admin'" :type="switchValue === true ? 'danger' : 'success'" size="small">{{switchValue === true ? '禁用' : '启用'}}</el-button>
                        </template>
                    </el-table-column>  
                    <template slot="empty">
                        <el-empty :image-size="200" description="未查询到任何用户，请添加或查看网络！"></el-empty>
                    </template> 
                </el-table>
                <!--分页信息底栏-->
                <el-pagination v-show="totalCount > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper"
                    :current-page="queryParams.pageNum" :page-sizes="[10, 20, 50]" :page-size="queryParams.pageSize" :total="totalCount" class="page">   
                </el-pagination>
            </div>
        </el-card>
        <!-- 新增/修改用户对话框-->        
        <el-dialog width="800px" :title="dialogTitle" :visible.sync="dialogVisible" :before-close="handleCloseDialog">
            <div>
                <el-form ref="dialogForm" :rules="rules" :model="dialogForm" label-width="80px">
                    <el-form-item label="用户名" prop="userName" v-if="propVisible">
                        <el-input v-model.trim="dialogForm.userId" v-if="false"></el-input>
                        <el-input v-model.trim="dialogForm.userName"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名" prop="relayName">
                        <el-input v-model.trim="dialogForm.relayName"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password" v-if="propVisible">
                        <el-input v-model.trim="dialogForm.password"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="userTel">
                        <el-input v-model.trim="dialogForm.userTel"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email">
                        <el-input v-model.trim="dialogForm.email"></el-input>
                    </el-form-item> 
                    <el-form-item label="性别" prop="userSex">
                        <el-select v-model="dialogForm.userSex" >
                            <el-option label="女" value="0"></el-option>
                            <el-option label="男" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="角色类别" prop="roleId" >
                        <el-select v-model="dialogForm.roleId" >
                            <el-option :label="item.roleName" v-for="item in roleList" :key="item.roleId" :value="item.roleId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="用户状态" prop="state" v-if="!propVisible">
                        <el-select v-model="dialogForm.state">
                            <el-option label="禁用" value="0"></el-option>
                            <el-option label="在用" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitUserInfo('dialogForm')" :loading="submitLoading">{{ submitLoading ? '提交中 ...' : '提 交' }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {queryUserList, addUser, modifyUserInfo, deleteUsers } from '../../api/user'
import {queryRoleList  } from '../../api/role'

export default {
    data() {
        return {
            totalCount: 0,                  //总数据条数
            queryParams: {
                userId: '',
                userName: null,
                relayName: null,
                state:'1',
                pageNum: 1,
                pageSize:10,
                orderByColumn:null,
                isAsc:null
            },
            userList: [],                   //表格数据
            roleList:[],                    //角色列表
            dialogVisible: false,           //对话框显示标志
            dialogForm: {},                 //对话框表单
            dialogTitle: '用户信息',         //对话框标题
            propVisible: true,              //对话框属性显示标志
            submitLoading: false,           //提交按钮加载
            switchValue:true,               //禁用开关
            multipleSelection:[],
            rules: {
                userName: [
                    {required: true, message: '用户名不能为空', trigger: 'blur'},               
                    {validator:function(rule,value,callback){
                        if(/^[a-zA-Z]{1}\w{4,11}$/.test(value) == false){
                            callback(new Error("由5到12位字母、数字和下划线组成，开头只能为字母，不区分大小写"));
                        }else{
                            callback();
                        }
                    }, trigger: 'blur'}  
                ],
                password: [
                    {required: true, message: '密码不能为空', trigger: 'blur'},
                    {min: 3, max: 15, message: '长度在 3 到 15 个字符',trigger: 'blur' },
                ],
                relayName: [
                    {required: true, message: '真实姓名不能为空', trigger: 'blur'},
                    {pattern: /^[\u4E00-\u9FA5]+$/, message: '真实姓名只能为中文',trigger: 'blur'}
                ],
                userSex: [
                    {required: true, message: '请选择性别', trigger: 'change'},
                ],
                email:[
                    {required: true, message: '请输入邮箱', trigger: 'blur'},
                ],
                userTel: [
                    {required: true, message: '请输入电话', trigger: 'blur' },
                    {validator: function (rule, value, callback) {
                    if (/^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/.test(value) == false) {
                        callback(new Error("请输入正确的手机号"));
                    } else {
                        callback();
                    }
                    }, trigger: 'blur'}
                ],
                roleId: [
                    {required: true, message: '请选择角色', trigger: 'change'},
                ],
            },

        };
    },
    created() {
        this.getUserList();
        this.getRoleList();
    },
    watch:{
        switchValue: function(newSwitchValue, oldSwitchValue){
            if(newSwitchValue === true){
                this.queryParams.state = '1';
            }else {
                this.queryParams.state = '0';
            }
            this.getUserList();
        }
    },
    methods: {
        // 分页查询用户信息
        getUserList(){
            const loading = this.$loading({
                lock: true,
                text: 'Loading.....',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            queryUserList(this.queryParams).then(res => {
                loading.close();     
                //console.log(res);     
                if(res.data.code === 200) {
                    this.userList = res.data.rows;
                    this.totalCount = res.data.total;
                }else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });  

                }
            }).catch( err => {
                loading.close();
            })
        },
        //查询所有角色
        getRoleList(){
            queryRoleList({state:'1'}).then(res => {
                this.roleList = res.data.data;
            })
        },
        //批量选择
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //批量删除
        deleteSelectedUsers(){
            if(this.multipleSelection.length <= 0){
                this.sendMsg("您未选择任何用户，无法删除！", "warning");
                return
            }
            let userIds= [];
            this.multipleSelection.forEach(item => {
                userIds.push(item.userId);
            })
            this.$confirm("此操作将永久删除所选用户, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                deleteUsers(userIds).then(res => {
                    //console.log(res);
                    if (res.data.code === 200) {
                        this.sendMsg("删除成功", "success");
                        this.getUserList();
                    }else {
                        this.sendMsg(res.data.msg, "error");
                    }
                })
            });
        },
        //改变当前记录条数
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.queryParams.pageNum = 1;
            this.getUserList();
        },
        //改变当前页码，重新发送请求
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getUserList();
        },                  
        //打开对话框
        openDialog(val){
            if(val === 'add'){
                //打开新增用户
                this.dialogTitle = '新增用户对话框';
                this.dialogForm = {};
                this.propVisible = true;
            }else{
                if(JSON.parse(this.$store.state.loginInfo).roles === '阅卷官' && (val.roles[0].roleName === '超级管理员' ||  val.roles[0].roleName === '阅卷官')) {
                    this.$message({
                        message: '您没有权限修改管理员的信息！',
                        type: 'warning'
                    });
                    return
                } else {
                    //根据userId向后台请求查询用户信息，将信息显示于对话框中
                    this.dialogTitle = '修改用户对话框';
                    this.propVisible = false;
                    this.dialogForm = {
                        userId: val.userId,
                        userName:val.userName,
                        password:val.password,
                        relayName: val.relayName,
                        userSex: val.userSex,               
                        userTel: val.userTel,
                        email: val.email,
                        roleId: val.roles[0].roleId,
                        state: val.state
                    }
                }
            }
            this.dialogVisible = true;
        },
        //提交用户信息
        submitUserInfo(formName) {             
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                    //角色需要传入数组，进行处理
                    this.dialogForm.roleIds = this.dialogForm.roleId.split(",");
                    delete this.dialogForm.roleId;        
                    if(this.propVisible){
                        addUser(JSON.stringify(this.dialogForm)).then(res => {
                            this.submitLoading = false; 
                            if(res.data.code === 200) {
                                this.dialogVisible = false;
                                this.$refs[formName].resetFields();
                                this.$message({
                                    message: '成功创建新用户！',
                                    type: 'success',
                                }); 
                                this.getUserList();
                            }else {
                                this.$message({
                                    message: res.data.msg,
                                    type: 'error'
                                });  

                            }
                        })
                    }else {
                        modifyUserInfo(JSON.stringify(this.dialogForm)).then(res => {
                            this.submitLoading = false;
                            if(res.data.code === 200) {
                                this.dialogVisible = false;
                                this.$refs[formName].resetFields();   
                                this.$message({
                                    message: '成功修改用户信息！',
                                    type: 'success',
                                })
                                this.getUserList();
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: 'error'
                                });  
                             
                            }
                        })
                    }
                } else {
                    this.$message({
                        message: '用户信息格式错误，请检查后重试！',
                        type: 'error'
                    });  
                }
            });            
        },
        //删除当前用户,走修改接口
        modifyState(row) { 
            if(JSON.parse(this.$store.state.loginInfo).roles === '阅卷官' && (val.roles[0].roleName === '超级管理员' ||  val.roles[0].roleName === '阅卷官')) {
                this.$message({
                    message: '不可禁用管理员',
                    type: 'warning'
                });
            } else {
                this.dialogForm = row;
                if(this.switchValue === true){
                    this.dialogForm.state = '0';
                }else {
                    this.dialogForm.state = '1';
                }

                const roleIds = [];
                if(row.roles.length >0 ){
                    for(let i = 0; i< row.roles.length; i++){
                        roleIds.push(row.roles[i].roleId);
                    }
                }
                this.dialogForm.roleIds = roleIds;
                modifyUserInfo(JSON.stringify(this.dialogForm)).then(res => {
                    if(res.data.code === 200) {
                        this.$message({
                            message: '成功修改用户信息！',
                            type: 'success',
                        })
                        this.dialogForm = {};
                        this.getUserList();
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: 'error'
                        });  
                        
                    }
                })
            }
          
        },
        //对话框关闭提醒
        handleCloseDialog(done) { 
            this.$confirm('确认关闭？').then(_ => {
                this.$refs['dialogForm'].resetFields();
                done();
            }).catch(_ => {});
        },
        //报送信息模板
		sendMsg(msg, type) {
			this.$message({
				message: msg,
				type: type
			});
		}
    },

};
</script>
<style lang="less" scoped>
    .fatherCard {
        width: 1672px;
        position: fixed;
        height: 90vh;
        .list_container {
            display: flex;
            flex-direction: column;
            align-items: center;
            .search_container {
                width: 100%;
                margin-bottom: 10px;
                display: flex;
                //align-items: flex-end;
                justify-content: space-between;
          
            }
             .el-pagination {
                margin-top: 15px;
            }
        }
    }
    .currentLocation {
        font-weight:bold
    }

    
   
   
  
  
    .searchinput {
        width: 200px;
        margin-right: 10px;
    }
    .switchDiv {
        display: flex;
        flex-flow: column;
        align-items: center;
    }
</style>
